module.exports = __webpack_public_path__ + "img/game--it-takes-two--pegi.c39d8d55.png";